<template>
    <section>
        <h1 class="text-center">{{$t('message.reset_password')}}</h1>
        <div class="text-center">
            {{user.reset.message}}
        </div>
        <form v-if="!hasResetCode" v-on:submit.prevent class="auth-form">
            <div class="form-group">
                <label>{{$t('message.email')}}</label>
                <input type="email" class="form-control" v-model="email" placeholder="Email">
            </div>
            <button type="submit" @click="resetPassword(email)" class="btn btn-default">
                <i class="fa fa-spin fa-spinner" v-if="user.reset.loading"></i>
                {{$t('message.reset_password')}}
            </button>
        </form>
        <div class="text-center">
            {{user.set.message}}
        </div>
        <form v-if="hasResetCode" v-on:submit.prevent class="auth-form">
            <div class="form-group">
                <label>{{$t('message.new_password')}}</label>
                <input type="password" class="form-control" v-model="password">
            </div>
            <div class="form-group">
                <label>{{$t('message.new_password_again')}}</label>
                <input type="password" class="form-control" v-model="passwordVerify">
            </div>
            <button type="submit" @click="setNewPassword" class="btn btn-default">
                <i class="fa fa-spin fa-spinner" v-if="user.set.loading"></i>
                {{$t('message.set_new_password')}}
            </button>
        </form>
    </section>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import mixins from '../modules/mixins'

    export default {
        name: 'ResetPassword',
        mixins: [mixins],
        data () {
            return {
                email: '',
                password: '',
                passwordVerify: ''
            }
        },
        methods: {
            ...mapActions('user', {
                resetPassword: 'resetPassword',
                checkResetCapability: 'checkResetCapability',
                setPassword: 'setPassword'
            }),
            setNewPassword () {
                if (this.password === this.passwordVerify) {
                    if (this.password.length < 8) {
                        this.notify('danger', this.$t('password_too_short'))
                        return
                    }
                    const password = this.password
                    this.setPassword({password})
                } else {
                    this.notify('danger', this.$t('passwords_not_match'))
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.user
            }),
            complete () {
                return this.user.set.complete
            },
            hasResetCode () {
                return Boolean(this.user.resetCapability.available)
            }
        },
        created () {
            this.checkResetCapability()
        },
        watch: {
            complete (value) {
                if (value) {
                    return this.$router.replace({'path': '/login'}).then(() => {
                        this.notify('info', this.user.set.message)
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .auth-form {
        max-width: 500px;
        margin: 0 auto;
        padding: 20px;
        border: 1px solid #e4e4e4;
        box-shadow: rgba(0, 0, 0, 0.1) 0 3px 6px 0;
        border-radius: 4px;
    }
</style>
